import { render, staticRenderFns } from "./SampleProcessingTabPortionEditableGrid.vue?vue&type=template&id=6cbc45c5&scoped=true&"
import script from "./SampleProcessingTabPortionEditableGrid.vue?vue&type=script&lang=js&"
export * from "./SampleProcessingTabPortionEditableGrid.vue?vue&type=script&lang=js&"
import style0 from "./SampleProcessingTabPortionEditableGrid.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SampleProcessingTabPortionEditableGrid.vue?vue&type=style&index=1&id=6cbc45c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc45c5",
  null
  
)

export default component.exports